import { Table, Tag, Button } from 'antd';
import paths from 'pages/Router/paths';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { setBreadcrumb } from 'state/actions/breadcrumb';
import { fetchRoles } from 'state/actions/roles';
import { fetchUsers } from 'state/actions/users';
import PageHeader from 'design-components/PageHeader';
import './Notifications.css';
import { fetchNotifications } from 'state/actions/notification';
import ModalDetailNotification from 'components/ModalDetailNotification';
import CategoryDropdown from 'components/CategoryDropdown';
import moment from 'moment';

export default function Notifications({ match }) {
  const [search, setSearch] = useState('');
  const [notification, setNotification] = useState();
  const [statusFilter, setStatusFilter] = useState('all');
  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  const {
    notificationList,
    siteList,
    mediaList,
    logsList,
    role,
    loading,
    error,
  } = useSelector(
    (state) => ({
      notificationList: state.notification.list,
      roleList: state.roles.list,
      siteList: state.sites.list,
      mediaList: state.media.list,
      logsList: state.logs.list,
      userList: state.users.list,
      loading: state.notification.loading,
      deleted: state.logs.deleted,
      role: state.auth.userData.role,
      error: state.logs.error,
      downloading: state.logs.downloading,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  // console.log(notificationList, 'notification');
  // useEffect(() => {
  //   if (role === 'admin' || role === 'superadmin') {
  //     dispatch(fetchAuthLogs({}));
  //   }
  // }, [dispatch, role]); // eslint-disable-line

  useEffect(() => {
    dispatch(fetchNotifications(statusFilter));
  }, [statusFilter]); //eslint-disable-line

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (statusDropdownOpen && !event.target.closest('.playlist-wrapper') && !event.target.closest('.playlist-dropdown')) {
        setStatusDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [statusDropdownOpen]);

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
  };

  useEffect(() => {
    dispatch(fetchUsers(match.params.id));
    dispatch(fetchRoles());
    dispatch(setBreadcrumb([{ menu: 'Notification', link: '/notification' }]));
  }, []); // eslint-disable-line

  const redirect = role === 'superadmin' ||  role === 'admin' ? false : <Redirect to={paths.ROOT} />;

  // Define status categories for the dropdown
  const statusCategories = [
    { _id: 'pending', name: 'Pending' },
    { _id: 'approved', name: 'Approved' },
    { _id: 'declined', name: 'Declined' },
  ];

  // Filter by search only (status filtering is done on backend)
  const filteredData = search
    ? notificationList.filter((el) => {
        const clonedElem = { ...el };
        const keyword = search.toLowerCase();
        return (
          clonedElem.name.toLowerCase().includes(keyword) ||
          clonedElem.page.toLowerCase().includes(keyword) ||
          clonedElem.modifiedBy.toLowerCase().includes(keyword) ||
          (clonedElem.approval && clonedElem.approval.toLowerCase().includes(keyword))
        );
      })
    : notificationList;

  const columns = [
    {
      title: 'Title',
      dataIndex: 'name',
      render: (text) => <div className="table-name">{text}</div>,
    },
    {
      title: 'Page',
      dataIndex: 'page',
    },
    {
      title: 'Last Modified At',
      dataIndex: 'modifiedAt',
      // sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
      render: (text, record) => {
        return (
          <div>{`${moment(record.modifiedAt).format(
            'DD-MM-YYYY HH:mm:ss'
          )} `}</div>
        );
      },
    },
    {
      title: 'Last Modified By',
      dataIndex: 'modifiedBy',
    },
    {
      title: 'Requested From',
      dataIndex: 'requestedBy',
    },{
      title: 'Authorized By',
      dataIndex: 'authorizedBy',
    },
    {
      title: 'Status',
      dataIndex: 'approval',
      // sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
      render: (text, record) => {
        if (record.approval) {
          switch (record.approval) {
            case 'pending':
              return <Tag color="gold">Pending Approval</Tag>;
            case 'approved':
              return <Tag color="green">Approved</Tag>;
            case 'declined':
              return <Tag color="red">Declined</Tag>;
            default:
              return <span>-</span>;
          }
        }
        return <span>-</span>;
      },
    },
    {
      title: 'Action',
      dataIndex: 'action',
      render: (text, record) => {
        return (
          <Button type="link" onClick={() => setNotification(record)}>
            See Details
          </Button>
        );
      },
    },
  ];

  const onUpdate = (notif) => {
    // dispatch(updateNotification({ id: notif._id, status: notif.status }));
  };

  const handleSetStatusFilter = () => {
    setStatusDropdownOpen(false);
  };

  return (
    <section className="notification">
      {redirect}
      <ModalDetailNotification
        isVisible={notification}
        data={notification}
        onUpdate={onUpdate}
        setData={setNotification}
        onCancel={() => setNotification(null)}
        currentStatusFilter={statusFilter}
      />

      <div className="media-header">
        <div className="media-header-left">
          <div className="searchbar-wrapper">
            <div className="searchbar">
              <i className="feather-search" />
              <input
                placeholder="Search here..."
                className="search-input"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div
            className="playlist-wrapper"
            onClick={() => setStatusDropdownOpen(!statusDropdownOpen)}
          >
            <div className="playlist-selection">
              <i className="feather-filter" style={{ marginRight: '8px' }} />
              <span>
                Status: {statusFilter === 'all' ? 'All' : statusCategories.find(s => s._id === statusFilter)?.name || 'All'}
              </span>
            </div>
            <i
              className={`feather-chevron-down ${
                statusDropdownOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <CategoryDropdown
              categories={statusCategories}
              tempSelectedCategory={statusFilter}
              setTempSelectedCategory={setStatusFilter}
              modalOpen={statusDropdownOpen}
              handleSetPlaylist={handleSetStatusFilter}
              filter={true}
              title="Status"
            />
          </div>
        </div>
      </div>

      <div>
        {!loading && Array.isArray(filteredData) ? (
          <Table
            columns={columns}
            dataSource={filteredData}
            rowKey="_id"
            pagination={tableParams.pagination}
            onChange={handleTableChange}
          />
        ) : (
          <ClipLoader />
        )}
        {error && 'Show error'}
      </div>
    </section>
  );
}
